import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ListItemText, makeStyles, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { ChevronRight } from '@material-ui/icons';
import clsx from 'clsx';
import { NavLink } from 'react-router-dom';
import { navMaxWidth, pxToRem, transitionSpeed } from '../../../../theme';
import { Badge } from '../Badge';
import { Icon } from '../Icon';
const useStyles = makeStyles((theme) => ({
    chevron: {
        color: theme.palette.secondary.main,
        transition: `transform ${transitionSpeed} ease-out`,
    },
    chevronCollapsed: {
        transform: 'rotate(90deg)',
    },
    linkContainer: {
        alignItems: 'center',
        color: 'inherit',
        display: 'flex',
        flex: `0 0 ${navMaxWidth}px`,
        padding: theme.spacing(1, 3),
        textDecoration: 'none',
        transition: `padding ${transitionSpeed} ease-out`,
        width: navMaxWidth,
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(1, 2),
        },
        '&:hover, &:focus': {
            backgroundColor: 'transparent',
            '& .MuiTypography-root': {
                fontWeight: 700,
            },
        },
        '&.active': {
            backgroundColor: 'transparent',
            '& .MuiTypography-root': {
                fontWeight: 600,
            },
            '& svg, & path': {
                color: '#424242',
                fill: '#424242',
            },
            '& .chevron': {
                transform: 'rotate(90deg)',
            },
            '& + .collapseContainer': {
                height: 'auto !important',
                visibility: 'visible',
            },
        },
        '& .MuiBadge-root:nth-child(2) .MuiBadge-badge': {
            top: -5,
            transition: 'none',
            visibility: 'visible',
        },
        '& .MuiBadge-invisible': {
            visibility: 'hidden',
        },
    },
    linkContainerCollapsed: {
        padding: theme.spacing(1, 3),
    },
    navText: {
        fontSize: pxToRem(14),
        opacity: 0,
        textAlign: 'left',
        transition: `opacity ${transitionSpeed} ease-out`,
        [theme.breakpoints.up('sm')]: {
            opacity: 1,
        },
    },
    navTextCollapsed: {
        opacity: 0,
    },
    navTextCollapsedOpen: {
        fontWeight: 700,
    },
}));
/**
 * Button link component for the `LeftNavItem`
 *
 * @param hasSublinks - Indicates whether the button link has sublinks.
 * @param icon - The icon to display in the button link.
 * @param isCollapsed - Indicates whether the button link is collapsed.
 * @param isMenuOpen - Indicates whether the menu is open.
 * @param text - The text to display in the button link.
 * @param tooltipText - The tooltip text to display.
 * @param onClick - Toggles the collapsible panel.
 */
export function PrimaryLink({ hasSublinks, icon, id, isActive, isCollapsed, isMenuOpen, shouldShowDot, status, testId, text, tooltipText, url, onClick, }) {
    const classes = useStyles();
    const theme = useTheme();
    const mediumScreenAndUp = useMediaQuery(theme.breakpoints.up('sm'));
    return (_jsxs(NavLink, { className: clsx(classes.linkContainer, {
            [classes.linkContainerCollapsed]: !isMenuOpen,
            active: isActive || isCollapsed,
        }), "data-testid": testId, id: `PrimaryLink-${id}`, to: url, onClick: onClick, children: [_jsx(Icon, { icon: icon, isCollapsed: isCollapsed, isMenuOpen: isMenuOpen, text: tooltipText || text }), shouldShowDot && _jsx(Badge, { shouldShowDot: !isMenuOpen || !mediumScreenAndUp, status: undefined }), _jsx(ListItemText, { children: _jsx(Typography, { className: clsx(classes.navText, {
                        [classes.navTextCollapsed]: !isMenuOpen,
                        [classes.navTextCollapsedOpen]: isCollapsed,
                    }), color: 'textPrimary', children: text }) }), _jsx(Badge, { shouldShowDot: shouldShowDot, status: status }), hasSublinks && (_jsx(ChevronRight, { className: clsx(classes.chevron, 'chevron', { [classes.chevronCollapsed]: isActive || isCollapsed }) }))] }));
}
